import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
`;

export const Divider = styled.div`
  border-left: 1px solid #c4c4c4;
  margin: 15px;
`;
